import React from "react";

const Container = ({ as: Tag = "div", className = "", children, ...rest }) => (
  <Tag
    className={`mx-auto w-full max-w-content px-[var(--gutter)] ${className}`}
    {...rest}
  >
    {children}
  </Tag>
);

export default Container;
